import React, { useState, useEffect } from "react";
import { CardWithoutSeeMore, CardWithStatus } from "../../components/Cards";
import { Link } from "react-router-dom";
import { TimeframeLineChart } from "../ProductInventory/InventoryCharts";
import { useSelector, useDispatch } from "react-redux";
import {
  getTotalStockValue,
  dashBoardStats,
  getOutOfStockProducts,
  getActivityLogs,
  getExpiryAlertCount,
  getStockRequestCount,
} from "../../redux/Inventory/inventoryActions";
import moment from "moment";

import EmptyState from "../../components/EmptyState";

import IndexActivityLog from "../ProductInventory/IndexActivityLog";
import OrdersOverviewTable from "./OrdersOverviewTable";

const StoreManagerOverview = () => {
  const dispatch = useDispatch();
  const {
    totalStockValue,
    loading,
    totalActiveProducts,
    lowStockProducts,
    activityLogs,
    activityLogsLoading,
    expiryAlertCount,
    stockrequestcount,
  } = useSelector((state) => state.inventory);
  const [period, setPeriod] = useState("12 months");
  const [currentPage] = useState(1);
  const [pageSize] = useState(10);

  useEffect(() => {
    // Fetch total stock value when the component mounts
    dispatch(getTotalStockValue());
    // Fetch dashboard stats
    dispatch(dashBoardStats());
    dispatch(getStockRequestCount());
    // Fetch out of stock count for accurate display
    dispatch(getOutOfStockProducts({ page: 1 }));
    // Fetch top 3 activity logs
    dispatch(getActivityLogs({ page: 1, page_size: 3 }));

    dispatch(getExpiryAlertCount());
  }, [dispatch, currentPage, pageSize]);

  return (
    <>
      <div className="bg-white border border-[#E1E6E1] flex justify-between rounded-lg py-5 px-4">
        <div>
          <h6 className="text-primary font-semibold text-lg">Overview</h6>
          <p className="text-[#5C715E] text-sm font-semibold mt-5">
            {moment().format("MMMM Do, YYYY")}
          </p>
        </div>
      </div>
      <div className="mt-6">
        <div className="grid grid-cols-2 gap-4">
          <div className="rounded-lg px-4 pt-4 pb-9 bg-[#FFFFFF] border border-[#E1E6E1]">
            <p className="text-[#5F6D60] font-semibold text-sm">
              Total Stock Value
            </p>
            <h2 className="text-2xl font-semibold mt-5 text-[#344335]">
              ₦ {loading ? "0" : totalStockValue.toLocaleString()}
            </h2>
          </div>

          <CardWithoutSeeMore
            title="Active Products"
            subtitle={totalActiveProducts}
            href=""
            hasStatus
          />
        </div>

        <div className="grid grid-cols-4 gap-4 mt-4">
          <CardWithStatus
            title="Low Stock Products"
            subtitle={lowStockProducts}
            href="/product-inventory/low-stock"
            hasStatus
            status="Urgent"
          />

          <CardWithStatus
            title="Expiry Alert"
            subtitle={expiryAlertCount}
            href="/product-inventory/expiry-alert"
            hasStatus
            status="Urgent"
          />

          <CardWithStatus
            title="Stock Request"
            subtitle={stockrequestcount ? stockrequestcount.created_count : 0}
            href={`/store-manager/stock-requests`}
            hasStatus
            status="Urgent"
          />

          <CardWithStatus
            title="Stock Requests to Dispatch"
            subtitle={
              stockrequestcount ? stockrequestcount.fulfillment_count : 0
            }
            href="/store-manager/stock-requests-to-dispatch"
            hasStatus
            status="Urgent"
          />
        </div>

        <div className="grid grid-cols-3 gap-4 mt-4">
          <div className="border col-span-2 border-[#E1E6E1] rounded-lg min-h-[360px] bg-white p-4">
            <div className="flex justify-between items-center">
              <div>
                <p className="font-semibold text-sm text-[#5F6D60]">
                  Stock Movement
                </p>
              </div>
              <div>
                {/* Timeframe Dropdown */}
                <div className="mb-4 ">
                  <select
                    value={period}
                    onChange={(e) => setPeriod(e.target.value)}
                    className="p-2 text-sm font-semibold text-[#5F6D60] focus:outline-none focus:ring-0"
                  >
                    <option value="12 months">12 Months</option>
                    <option value="3 months">3 Months</option>
                    <option value="7 days">7 Days</option>
                  </select>
                </div>
              </div>
            </div>
            <TimeframeLineChart period={period} />
          </div>
          {/* Activity log */}
          <div className="bg-white border border-[#E1E6E1] rounded-lg h-full">
            <div className="flex border-b border-[#E1E6E1] justify-between items-center p-4">
              <p className="text-sm text-[#2E332F] font-semibold">
                Activity Log
              </p>
              <Link
                to="/product-inventory/activity-log"
                className="text-sm text-[#2B8C34] font-semibold cursor-pointer hover:underline"
              >
                Show More
              </Link>
            </div>
            <div className="overflow-y-auto ">
              {activityLogsLoading ? (
                <div className="animate-pulse w-full py-4 px-4">
                  <div className="h-12 bg-gray-200 rounded-lg w-full mb-4"></div>
                  <div className="h-12 bg-gray-200 rounded-lg w-full mb-4"></div>
                  <div className="h-12 bg-gray-200 rounded-lg w-full mb-4"></div>
                  <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
                </div>
              ) : !activityLogs || activityLogs.length === 0 ? (
                <div className="py-8">
                  <EmptyState text="No recent activities" />
                </div>
              ) : (
                activityLogs.map((activity, index) => (
                  <IndexActivityLog key={index} activity={activity} />
                ))
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Orders table */}
      <OrdersOverviewTable />
    </>
  );
};

export default StoreManagerOverview;
